import type { ActionApi, SelectedColumns } from '../../../../common/types/index.tsx';

export const setSelectedColumns =
	(newSelectedColumns: SelectedColumns): ActionApi =>
	async ({ setState }) => {
		setState({
			selectedColumns: newSelectedColumns,
		});
	};
